import { post } from '@eika-infrastruktur/request';

import { getRequestOptions } from '../../meldskade/reducer/skademelding-actions';
import { EttersendingDTO } from '../../types/generated-types';
import { hentEttersendingUrl } from '../../urler';
import { InternalAttachment } from '../form/attachment-types';

export enum EttersendingActionKeys {
    SetSkadenummer = 'SET_SKADENUMMER',
    SetSkadesakExists = 'SET_SKADESAK_EXISTS',
    AddUploadedAttachments = 'ADD_ATTACHMENT',
    DeleteUploadedAttachment = 'DELETE_ATTACHMENT',
    SaveEttersending = 'SAVE_ETTERSENDING',
    SaveEttersendinggSuccess = 'SAVE_ETTERSENDING_SUCCESS',
    SaveEttersendingFailure = 'SAVE_ETTERSENDING_FAILURE',
    SaveEttersendingVedleggFailure = 'SAVE_ETTERSENDING_VEDLEGG_FAILURE',
    SaveEttersendingUnauthorizedFailure = 'SAVE_ETTERSENDING_UNAUTHORIZED_FAILURE',
}

export interface SetSkadenummerAction {
    type: EttersendingActionKeys.SetSkadenummer;
    skadenummer: string;
}

export const setSkadenummer = (skadenummer: string): SetSkadenummerAction => ({
    type: EttersendingActionKeys.SetSkadenummer,
    skadenummer,
});

export interface SetSkadesakExistsAction {
    type: EttersendingActionKeys.SetSkadesakExists;
    doesSkadesakExist: boolean;
}

export const setSkadesakExists = (doesSkadesakExist: boolean): SetSkadesakExistsAction => ({
    type: EttersendingActionKeys.SetSkadesakExists,
    doesSkadesakExist,
});

export interface AddUploadedAttachmentsAction {
    type: EttersendingActionKeys.AddUploadedAttachments;
    attachments: InternalAttachment[];
}

export const addUploadedAttachments = (attachments: InternalAttachment[]): AddUploadedAttachmentsAction => ({
    type: EttersendingActionKeys.AddUploadedAttachments,
    attachments,
});

export interface DeleteUploadedAttachmentAction {
    type: EttersendingActionKeys.DeleteUploadedAttachment;
    attachmentsToBeDeleted: InternalAttachment[];
}

export const deleteUploadedAttachment = (
    attachmentsToBeDeleted: InternalAttachment[],
): DeleteUploadedAttachmentAction => ({
    type: EttersendingActionKeys.DeleteUploadedAttachment,
    attachmentsToBeDeleted,
});

export interface SaveEttersendingAction {
    type: EttersendingActionKeys.SaveEttersending;
}

export const saveEttersending = (): SaveEttersendingAction => ({
    type: EttersendingActionKeys.SaveEttersending,
});

export interface SaveEttersendingSuccessAction {
    type: EttersendingActionKeys.SaveEttersendinggSuccess;
}

export const saveEttersendingSuccess = (): SaveEttersendingSuccessAction => ({
    type: EttersendingActionKeys.SaveEttersendinggSuccess,
});

export interface SaveEttersendingFailureAction {
    type: EttersendingActionKeys.SaveEttersendingFailure;
}

export const saveEttersendingFailure = (): SaveEttersendingFailureAction => ({
    type: EttersendingActionKeys.SaveEttersendingFailure,
});

export interface SaveEttersendingVedleggFailureAction {
    type: EttersendingActionKeys.SaveEttersendingVedleggFailure;
}

export const saveEttersendingVedleggFailure = (): SaveEttersendingVedleggFailureAction => ({
    type: EttersendingActionKeys.SaveEttersendingVedleggFailure,
});

export interface SaveEttersendingUnauthorizedFailureAction {
    type: EttersendingActionKeys.SaveEttersendingUnauthorizedFailure;
}

export const saveEttersendingUnauthorizedFailure = (): SaveEttersendingUnauthorizedFailureAction => ({
    type: EttersendingActionKeys.SaveEttersendingUnauthorizedFailure,
});

export const sendEttersendingApi = async (ettersendingBesvarelse: EttersendingDTO, bankregnr: string): Promise<void> =>
    post<void>(hentEttersendingUrl(), ettersendingBesvarelse, getRequestOptions(bankregnr));
